module.exports = __webpack_public_path__ + "img/aboutUs59.2ebf00f2.png";